import { XyoWorldGeotokens } from '@xyo-network/sdk-xyoworld-js'
import { createContext } from 'react'

export const GeotokensContext = createContext<{ geotokens?: XyoWorldGeotokens | null }>({})
